<template>
  <svg aria-hidden="true" :class="svgClass">
    <use :xlink:href="icon"></use>
  </svg>
</template>

<script>
export default {
  name: 'svg-cion',
  props: {
    name: {
      type: String,
      required: true
    },
    className: {
      type: String
    }
  },
  computed: {
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
    icon () {
      return `#icon-${this.name}`
    }
  }
}
</script>
<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
